import { render } from "./CustomTags.vue?vue&type=template&id=924c7180&scoped=true"
import script from "./CustomTags.vue?vue&type=script&lang=js"
export * from "./CustomTags.vue?vue&type=script&lang=js"

import "./CustomTags.vue?vue&type=style&index=0&id=924c7180&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-924c7180"]])

export default __exports__